import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Construction } from '../Construction/Construction'
import { Hospitality } from '../Hospitality/Hospitality'
import { Manufacturing } from '../Manufacturing/Manufacturing'
import s from './OurReferences.module.css'

export const OurReferences = () => {
	const { t } = useTranslation()

	const [switcher, setSwitcher] = useState(0)
	const handlerClick = props => {
		setSwitcher(props)
	}

	let content = (
		<>
			<Hospitality />
			<Manufacturing />
			<Construction />
		</>
	)

	if (switcher === 1) {
		content = <Hospitality />
	}
	if (switcher === 2) {
		content = <Manufacturing />
	}
	if (switcher === 3) {
		content = <Construction />
	}

	return (
		<div className={s.OurReferences}>
			<div className={s.Wrapper}>
				<ul className={s.Switcher}>
					<li>
						<button onClick={() => handlerClick(0)}>{t('all')}</button>
					</li>
					<li>
						<button onClick={() => handlerClick(1)}>{t('hospitality')}</button>
					</li>
					<li>
						<button onClick={() => handlerClick(2)}>
							{t('manufacturing')}
						</button>
					</li>
					<li>
						<button onClick={() => handlerClick(3)}>{t('construction')}</button>
					</li>
				</ul>
				{content}
			</div>
		</div>
	)
}
